import { TooltipWrapper } from "@/components/ui/shadcn/Tooltip/TooltipWrapper";
import { Info } from "lucide-react";

interface MatterContactConnectionDescriptionIconProps {
  description?: string | null;
}

export const MatterContactConnectionDescriptionIcon = ({
  description,
}: MatterContactConnectionDescriptionIconProps) => {
  const trimmedDescription = description?.trim();

  if (!trimmedDescription) {
    return null;
  }

  return (
    <TooltipWrapper message={`Description: ${trimmedDescription}`}>
      <span className="text-muted-foreground inline-flex">
        <Info className="h-4 w-4" />
      </span>
    </TooltipWrapper>
  );
};
